import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'diffLog',
})
export class DiffLogPipe implements PipeTransform {
  transform(logId: string, diffLogIds: Set<string>, isEHF: boolean): boolean {
    return (diffLogIds?.has(logId) || !logId) && isEHF;
  }
}
